import { Component, OnInit } from '@angular/core';

interface Plan {
  id: string;
  title: string;
  price: string;
  period: string;
  isPopular: boolean;
  features: PlanFeature[];
  ctaText: string;
  ctaOutline?: boolean;
}

interface PlanFeature {
  name: string;
  included: boolean;
  value?: string;
  items?: string[];
}

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  standalone: false
})
export class PricingComponent implements OnInit {
  plans: Plan[] = [
    {
      id: 'starter',
      title: 'Starter',
      price: '49',
      period: '/mes',
      isPopular: false,
      features: [
        {
          name: 'Interacciones',
          included: true,
          value: 'Hasta 1,000/mes'
        },
        {
          name: 'Canales',
          included: true,
          items: ['Web']
        },
        {
          name: 'Analítica',
          included: true,
          value: 'Panel básico'
        },
        {
          name: 'Integraciones',
          included: false,
          value: 'No incluido'
        },
        {
          name: 'Soporte',
          included: true,
          value: 'Email'
        }
      ],
      ctaText: 'Comenzar prueba gratis'
    },
    {
      id: 'pro',
      title: 'Pro',
      price: '149',
      period: '/mes',
      isPopular: true,
      features: [
        {
          name: 'Interacciones',
          included: true,
          value: 'Hasta 10,000/mes'
        },
        {
          name: 'Canales',
          included: true,
          items: ['Web', 'WhatsApp']
        },
        {
          name: 'Analítica',
          included: true,
          value: 'Panel avanzado'
        },
        {
          name: 'Integraciones',
          included: true,
          value: 'API básica'
        },
        {
          name: 'Soporte',
          included: true,
          value: 'Prioritario'
        }
      ],
      ctaText: 'Comenzar prueba gratis'
    },
    {
      id: 'enterprise',
      title: 'Enterprise',
      price: 'Personalizado',
      period: '',
      isPopular: false,
      features: [
        {
          name: 'Interacciones',
          included: true,
          value: 'Ilimitadas'
        },
        {
          name: 'Canales',
          included: true,
          items: ['Web', 'WhatsApp', 'Canales personalizados']
        },
        {
          name: 'Analítica',
          included: true,
          value: 'Panel personalizado'
        },
        {
          name: 'Integraciones',
          included: true,
          items: ['CRM', 'ERP', 'Sistemas personalizados']
        },
        {
          name: 'Soporte',
          included: true,
          value: 'SLA dedicado'
        }
      ],
      ctaText: 'Contactar ventas',
      ctaOutline: true
    }
  ];

  // Variables para mostrar/ocultar elementos en vista móvil
  showMobileCards = window.innerWidth < 768;

  constructor() { }

  ngOnInit(): void {
    // Para controlar la vista responsiva
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  checkScreenSize(): void {
    this.showMobileCards = window.innerWidth < 768;
  }
}